// extracted by mini-css-extract-plugin
export default {"defaultButton":"DefaultButton_defaultButton__8XT4y","disabledButton":"DefaultButton_disabledButton__lEy-0"};